<script setup>
import { useI18n } from "vue-i18n";
import TextContentSection from "./Blocks/TextContentSection.vue";
import TextOptionsSection from "./Blocks/TextOptionsSection.vue";
import ImageSection from "./Blocks/ImageSection.vue";
import EmbedSection from "./Blocks/EmbedSection.vue";

defineEmits(["addBlock", "start", "end"]);

const { t: __ } = useI18n();
</script>

<template>
    <div class="rounded-lg border border-gray-300 dark:border-gray-800">
        <TextContentSection @add-block="$emit('addBlock', $event)" class="rounded-t-lg border-t-0" @start="$emit('start')" @end="$emit('end')" />
        <TextOptionsSection @add-block="$emit('addBlock', $event)" @start="$emit('start')" @end="$emit('end')" />
        <ImageSection @add-block="$emit('addBlock', $event)" @start="$emit('start')" @end="$emit('end')" />
        <EmbedSection
            @add-block="$emit('addBlock', $event)"
            class="rounded-b-lg data-[headlessui-state=open]:rounded-b-none"
            @start="$emit('start')"
            @end="$emit('end')" />
    </div>
</template>
